import {SODeleteProcess} from '../../core/process/so-delete-process';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteProcess extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteProcess;
}